/**
 * Turns a report's own name into a document title that is safe as a file name.
 * Browsers name the saved PDF from `document.title`, so whatever this returns
 * is what the user sees in the save dialog.
 */

const MAX_TITLE_LENGTH = 80

// Characters a file name cannot hold on common systems, plus control characters.
// eslint-disable-next-line no-control-regex
const ILLEGAL_CHARS = /[/\\:*?"<>|\u0000-\u001F\u007F]/g
const DASHES = /[–—]/g

export function buildPrintDocumentTitle(
  name: string | null | undefined,
  fallback: string,
): string {
  let cleaned = (name ?? '')
    .replace(DASHES, '-')
    .replace(ILLEGAL_CHARS, ' ')
    .replace(/\s+/g, ' ')
    .trim()

  if (cleaned.length > MAX_TITLE_LENGTH) {
    const cut = cleaned.slice(0, MAX_TITLE_LENGTH)
    const lastSpace = cut.lastIndexOf(' ')
    cleaned = lastSpace > MAX_TITLE_LENGTH / 2 ? cut.slice(0, lastSpace) : cut
  }

  cleaned = cleaned.replace(/^[.\s]+|[.\s]+$/g, '')

  return cleaned.length > 0 ? cleaned : fallback
}
